import { useEffect, useRef, useState } from "react"
import AdminNavBar from "./AdminNavBar"
import LocationNavBar from "./LocationNavBar"

const DeleteLocation = () => {
	const [msg, setMsg] = useState("")

	interface Location {
		id: number;
		short_name: string;
		long_name: string;
	}

	var locationRef = useRef<HTMLSelectElement>(null)
	const [locations, setLocations] = useState<Location[]>([])
	const [selectedLocation, setSelectedLocation] = useState<Location>({ id: 0, short_name: "", long_name: "" })
	const [isVisible, setIsVisible] = useState(false)

	const handleSelectChange = async () => {
		if (locationRef && locationRef.current) {
			const id = locationRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/locationByID?id=" + id);
			const location = await response.json()
			setSelectedLocation(location)
			setIsVisible(true)
			setMsg("")
		}
	}

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations")
		if (response) {
			const locations = await response.json()
			setLocations(locations)
		}
	}
	
	const handleDelete = async () => {
		if (locationRef && locationRef.current) {
			const id = locationRef.current.value
			
			const resp = await fetch(process.env.REACT_APP_API+"/api/locations?id=" + id, {
				method: "DELETE",
			});

			if (resp.status === 200) {
				setMsg("Deleted " + selectedLocation.long_name + " successfully")
			} else {
				setMsg("Failed to delete " + selectedLocation.long_name)
			}
			
			getLocations()
			setIsVisible(false)
			setSelectedLocation({ id: 0, short_name: "", long_name: "" })
		}
	}

	useEffect(() => {
		getLocations()
	}, [])

		return (
		<div className="resilire">
			<AdminNavBar />
			<LocationNavBar />
			<h3>Delete Location</h3>
			<select id="units" onChange={handleSelectChange} ref={locationRef}>
				<option value=""></option>
				{locations.map((location) => (
					<option value={location.id} key={location.id}>{location.long_name}</option>
				))}
			</select>
			{isVisible && (
				<div className="resilire">
					<button onClick={() => handleDelete()}>Delete {selectedLocation.long_name}</button>
				</div>
			)}
			<p>{msg}</p>
		</div>
	)
}

export default DeleteLocation;
